/* eslint-disable */
import {
  Button,
  Image,
  Spin, Typography
} from 'antd';
import { FineUploaderBasic } from 'fine-uploader/lib/core';
import React, { useEffect, useRef, useState } from 'react';

import Icon from 'components/atoms/Icon';
import CameraCapture, { CameraCaptureRef } from 'components/organisms/CameraCapture';
import { ERR_UPLOAD_RES, URL_CONST } from 'utils/constants';
import { compressImageFile } from 'utils/functions';

export type UploadFileType = {
  file?: File | string;
  pathSubmit: string;
};

type ChunkErrorResTypes = {
  detail: string;
  source: {
    pointer: string
  };
  status: number;
  title: string;
};

interface UploadPhotoProps {
  description: string,
  title?: string,
  handleChooseFile: (file: UploadFileType) => void;
  handleRemoveFile: () => void;
  handleError?: (message: string) => void;
  readOnly?: boolean;
  value?: UploadFileType;
  className?: string;
  idUpload: string;
  big?: boolean
}

const UploadPhoto: React.FC<UploadPhotoProps> = ({
  description,
  title,
  handleChooseFile,
  handleRemoveFile,
  handleError,
  readOnly,
  value,
  className,
  idUpload,
  big
}) => {
  const [preview, setPreview] = useState<string>('');
  const [loading, setLoading] = useState(false);
  const [openCapture, setOpenCapture] = useState<number>(-1);

  const fileRef = useRef<File | undefined>(undefined);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const carmeraRef = useRef<CameraCaptureRef>(null);

  const uploader = new FineUploaderBasic({
    autoUpload: false,
    request: {
      endpoint: URL_CONST.FILE_UPLOAD_CHUNK,
    },
    validation: {
      allowedExtensions: ['jpeg', 'jpg', 'png'],
      sizeLimit: 1000000,
    },
    chunking: {
      enabled: true,
      mandatory: true,
      partSize: 1000000, // 1MB
      success: {
        jsonPayload: true,
        endpoint: URL_CONST.FILE_MERGE_CHUNK,
        params(id: number) {
          const uuid = uploader.getUuid(id);
          const { type } = (uploader.getFile(id) as File);
          return {
            chunkedUuid: uuid,
            fileExtension: type.split('/').length > 1 ? type.split('/')[1] : type,
          };
        }
      },
    },
    callbacks: {
      onSubmit(id: number) {
        const file = uploader.getFile(id);
        if (file && file.size > 1000000) {
          if (handleError) {
            handleError('File size must be less than 1MB');
          }
          uploader.cancel(id); // Cancel upload if file is too large
          setLoading(false);
          // return false;
        }
      },
      onComplete(id: number, name: string, res: any, xhr: XMLHttpRequest) {
        const file = uploader.getFile(id);
        handleChooseFile({
          file,
          pathSubmit: (res.errors as ChunkErrorResTypes[])?.[0].status === 422
            ? ERR_UPLOAD_RES.inValidSize : res?.data?.path
        });
        setLoading(false);
        // const uuid = uploader.getUuid(id);
        // const file = uploader.getFile(id);
        // setUuidImages((prev) => [...prev,
        // { chunkedUuid: uuid, fileExtension: file.name.split('.').pop() }]);

        // if (!res.success) {
        //   const errors = JSON.parse(xhr.response).errors as ValidateError[];
        // } else {
        // }
      },
      onError: async (id: number, name: string, errorReason: string, xhr: XMLHttpRequest) => {
        setLoading(false);
      },
    }
  });

  const handleUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e?.target?.files?.[0];

    if (file) {
      try {
        const compressedFile = await compressImageFile(file, big) as File;
        fileRef.current = compressedFile;
        setLoading(true);
        uploader.addFiles(compressedFile);
        uploader.uploadStoredFiles();
      } catch (err) {
        console.log('Upload error: ', err);
      }
    }
  };

  const openFilePicker = () => {
    fileInputRef.current?.click();
  };

  const handleFinishCapture = (photos: File[]) => {
    // if (photos.length) {

    //   setOpenCapture(-1);
    // }
    if (photos && photos.length > 0) {
      setLoading(true);
      setOpenCapture(-1);
      uploader.addFiles([photos[0]]);
      uploader.uploadStoredFiles();
    }
  };

  // const handleCheckFaceId = useCallback((photos: File[]) => {
  //   if (photos && photos.length > 0) {
  //     setLoading(true);
  //     uploader.addFiles([photos[0]]);
  //     uploader.uploadStoredFiles();
  //   }
  // }, [uploader]);

  useEffect(() => {
    if (value && value.file) {
      setPreview(typeof value.file === 'string' ? value.file : URL.createObjectURL(value.file));
    } else if (value?.pathSubmit) {
      setPreview(value?.pathSubmit);
    } else {
      setPreview('');
    }
  }, [value]);

  return (
    <div className={`m-uploadPhoto ${className}`}>
      {
        loading && (
          <div className="m-uploadPhoto_loading">
            <Spin size="default" spinning />
          </div>
        )
      }
      {
        preview ? (
          <div className="m-uploadPhoto_wrapImage">
            {
              !readOnly && (
                <div
                  onClick={() => {
                    handleRemoveFile();
                    setPreview('');
                    fileRef.current = undefined;
                  }}
                  className="m-uploadPhoto_icon"
                >
                  <Icon iconName="clearImage" size="24" />
                </div>
              )
            }
            <Image
              src={preview}
              alt="review"
              className="m-uploadPhoto_image"
            // extendClasses="m-uploadPhoto_image"
            />
          </div>
        ) : (
          <div className="m-uploadPhoto_wrapContent">
            <Icon iconName="uploadPhoto" size="24" />
            <div className="u-mt-8">
              <Typography.Text
                className="fs-12x20"
              >
                {description}
              </Typography.Text>
            </div>
            <label htmlFor={idUpload} className="m-uploadPhoto_wrapContent_button">
              <input
                ref={fileInputRef}
                id={idUpload}
                disabled={readOnly}
                readOnly={readOnly}
                type="file"
                onChange={handleUpload}
                accept="image/*"
                className="m-uploadPhoto_file"
              />
            </label>
            <div className="u-mt-8" style={{ display: 'flex', gap: 20 }}>
              <Button onClick={openFilePicker}>
                Thư viện ảnh
              </Button>
              <Button onClick={() => setOpenCapture(0)}>Chụp ảnh</Button>
            </div>
          </div>
        )
      }
      {
        openCapture !== -1 && (
          <CameraCapture
            ref={carmeraRef}
            isSingle
            loading={loading}
            handleBack={() => setOpenCapture(-1)}
            handleFinish={handleFinishCapture}
            name={`cccd-${openCapture}`}
          // handleCheckFaceId={handleCheckFaceId}
          />
        )
      }
    </div>
  );
};

export default UploadPhoto;
